// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  features/dashboard/services/executivoService.ts
//  Agregado único do Dashboard Executivo (espelha DashboardExecutivoDtos.cs).
//  Substitui a agregação client-side dos hooks useFluxoCaixa/useFinanceKPIs.
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';

export interface ExecutivoSaude {
  saldoPrevisto: number;
  contasAtrasadas: number;
  /** % por valor da carteira aberta de recebíveis vencida. */
  taxaInadimplencia: number;
  emAbertoReceber: number;
  emAbertoPagar: number;
}

export interface ExecutivoMes {
  entradas: number;
  saidas: number;
  ticketMedioRecebimento: number;
  ticketMedioPagamento: number;
}

export interface ExecutivoPontualidade {
  taxaRecebimentoNoPrazo: number;
  /** Dias; positivo = após o vencimento, negativo = antes. */
  prazoMedioRecebimentoDias: number;
  taxaPagamentoNoPrazo: number;
  prazoMedioPagamentoDias: number;
}

export interface ExecutivoEvolucaoMes {
  ano: number;
  mes: number;
  entradas: number;
  saidas: number;
  saldo: number;
}

export interface ExecutivoDespesaGrupo {
  grupo: string;
  valor: number;
}

export interface ExecutivoFluxoDia {
  /** ISO "yyyy-MM-dd". */
  dia: string;
  entradas: number;
  saidas: number;
}

export interface DashboardExecutivoDados {
  saude: ExecutivoSaude;
  mesCorrente: ExecutivoMes;
  pontualidade: ExecutivoPontualidade;
  evolucaoTrimestral: ExecutivoEvolucaoMes[];
  despesasPorGrupo: ExecutivoDespesaGrupo[];
  fluxoDiario: ExecutivoFluxoDia[];
}

export const executivoService = {
  get: async (): Promise<DashboardExecutivoDados> =>
    (await apiClient.get('/api/dashboard/executivo')).data,
};
